import React, { ReactNode } from "react";
import styles from "./machine-structure-drop-area-deactivation-overlay-container.module.scss";
import cn from "classnames";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";

interface MachineStructureDropAreaDeactivationOverlayContainerPropTypes {
  children: ReactNode;
}

const cssClassName =
  "machine-structure-drop-area-deactivation-overlay-container";

export const MachineStructureDropAreaDeactivationOverlayContainer = ({
  children,
}: MachineStructureDropAreaDeactivationOverlayContainerPropTypes) => {
  const showMachineStructureDropAreaDeactivationOverlayState = useSelector(
    (state: RootState) =>
      state.yourSlice.showMachineStructureDropAreaDeactivationOverlay,
  );

  return (
    <div
      className={cn(styles[cssClassName], {
        [styles[`${cssClassName}--activate`]]:
          showMachineStructureDropAreaDeactivationOverlayState,
      })}
    >
      {children}
    </div>
  );
};
